import React, { ReactNode } from 'react'
import './PropertyGrid.css'
import slugify from 'react-slugify'

export type Property = {
  name: string
  value: ReactNode
}

export type Props = {
  'cy-prefix'?: string
  properties: {
    [key: string]: ReactNode
  }
}

function PropertyGrid(props: Props) {
  const { properties } = props
  const cyPrefix = props['cy-prefix'] ? props['cy-prefix'] + '-' : ''

  return (
    <div className="property-grid">
      {Object.keys(properties).map((key: string) => (
        <React.Fragment  key={`key-${key}`}>
          <div>
            <b>{key}</b>
          </div>
          <div data-cy={cyPrefix + slugify(key)}>
            {properties[key]}
          </div>
        </React.Fragment>
      ))}
    </div>
  )
}

export default PropertyGrid
